import React from "react";

const aneesh_topkar = () => {
  return (
    <div>
      <h1>Aneesh Topkar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students from all branches were allowed to apply for this internship
        except those with active backlogs, who weren’t allowed to sit for the
        process.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        There were 3 interview rounds scheduled back-to-back on the same
        day(Superday). These interviews were scheduled a week after the aptitude
        test and the results were announced on the same day, after the
        interviews.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        General Maths and aptitude questions, one coding question was on AVL
        trees.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />A total of 29 candidates were shortlisted after the aptitude
        round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        As I mentioned earlier, the interviews were a week after the aptitude
        test. The aptitude test results were announced 2 days later, giving us 5
        days to prepare. During this period, I focused on preparing all DSA
        concepts and continued solving typical Leetcode questions. I also
        brushed up on my projects and made sure I knew each and every detail
        about them, as the interviewer always asks about the nuances within your
        projects and judges you based on your fundamentals.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        A total of 3 rounds.
        <br />
        <strong>Round 1</strong>
        <br />
        Interviewer started with a basic introduction of myself. Moved on to my
        projects and asked me extensively about JWT as I had used it in my MERN
        fullstack website project. Basics of JWT and my Contact Us page, website
        structure and development. Also asked about rate limiting and my
        workflow - SDLC model(Answer). Moved on to DSA project in C(using
        Djikstra), asked about real world applications, openstreet, nominatim,
        reverse geocoding(project specifics), etc.
        <br />
        Started with DSA - given a binary search tree, find two elements whose
        sum equals a target value provided by him. Approach: Inorder, sorted
        array, two pointers. He accepted this approach and asked me to write the
        pseudocode only.
        <br />
        Lasted for about 40 mins.
      </p>

      <p>
        <strong>Round 2</strong>
        <br />
        I began with an introduction. The interviewer moved to projects and
        asked basic questions about React - diff between useCallback() and
        useMemo(); useEffect -&gt; syntax and how I used it in the project.
        <br />
        Moved on to DSA - 1) Given an unsorted array, and a value k; find
        maximum contiguous subarray sum where subarray is of size k.
        <br />
        2) Reverse a string using recursion only, no helper functions, no
        arguments passing(like index), no global array storage.
        <br />
        Ended with a puzzle - blindfolded, 10 coins, two sets of 5 coins each,
        in total there are 5 heads and 5 tails - flip any number so that when
        the blindfold is removed, we get an equal number of heads and tails for
        both the groups.
        <br />
        Lasted for about 45-50 mins.
      </p>

      <p>
        <strong>Round 3</strong>
        <br />
        Started with OS, asked about process ids and whether they are local or
        global, asked about system calls; moved to paging and segmentation from
        Computer Organisation, asked about page table and indexing, moved to my
        dsa project, asked about Dijsktra and why it does not have negative
        weights, other implementation questions about my project, finally went
        to Git, asked me about what kind of code diff algorithm they use.
        <br />
        This was the hardest round and complete answers were not expected, focus
        was more on basic understanding of fundamentals of OS and Computer
        Organisation.
        <br />
        Lasted for about 30 mins.
      </p>

      <p>There was no HR round.</p>

      <p>
        I believe that out of 29, 21 were selected for the next round, 15 were
        selected for the final round, out of those only 8 were called to give
        the final interview and 3 were selected at the end. (Numbers may not be
        entirely accurate).
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        DSA was asked in plenty. Trees, graphs, Linked lists and arrays were
        some of the topics that were in the mix and a variety of questions based
        on these were asked to all. For my final interview, OS was crucial and
        Computer Organisation was also important. As I had not included Computer
        Networks in my resume, I was not asked any questions about it.
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Striver(TUF) is one of the best resources that I can recommend for DSA.
        Well curated sheets like Striver A2Z sheet, 79 sheet really helped me
        prepare. I also used youtube extensively for web dev fundamentals.
        <br />
        Some good channels are:
        <br />
        Chai Aur Code
        <br />
        Traversy Media
        <br />
        FreeCodeCamp has excellent tutorials, only catch is you might get stuck
        in tutorial hell 🙂
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Be calm and confident in your preparation. Practice as many different
        problems from Leetcode as you can. Leetcode 75 was my personal
        favourite, but Hackerrank and other platforms are equally good. Remember
        to brush up on all core algorithms and basic Leetcode Medium questions.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Questions about my projects formed the basis for all 3 of my interviews.
        I would say, after DSA, projects were the next most important. I had 3
        projects in total, one of DSA, and 2 in web development. A lot of
        questions focused on the little things in my projects, so make sure to
        revise everything even remotely related to your projects.{" "}
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Prepare a little bit of everything. The interviewer loves puzzles and
        Goldman is famous for giving puzzles to crack during the interviews. If
        you can solve one, it leaves a great impression on the interviewer 🙂.
        Solving the puzzle has the potential to make or break your interview.
        You can prepare for the puzzles by looking them up on GFG - they have a
        vast and wonderful collection of puzzles.
        <br />
        Always remember to think out loud, the interviewer always tests your
        approach rather than perfect code. Even if you cannot give the syntax,
        your approach is crucial and more valued.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Honesty is the best policy🙂. The interviewer can easily figure out if
        you are bluffing or not, so if you are unable to answer; convey it
        honestly to the interviewer. You are obviously not expected to know
        everything that the interviewer may ask, and you are often judged on how
        graciously you can admit you do not know the answer. Always ask where
        you can improve, after each interview, it leaves a good impression and
        forces the interviewer to evaluate you in his/her mind and provide
        relevant feedback.
        <br />
        Also, only include those topics and projects where you are 100%
        confident. A short resume well explained creates a better impression
        than a 3 page document poorly explained.
        <br />
        Do not despair even if others around you receive internship offers,
        everyone is different and apart from the interviewer and the candidate ,
        no one knows what happens in those 40-45 mins. Your opportunity will
        present itself, when it does, give it all you have and give your best
        shot!
        <br />
        Wishing you all the very best for your interviews!{" "}
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:topkarak23.comp@coeptech.ac.in">topkarak23.comp@coeptech.ac.in</a>
      </p>

      <hr />
    </div>
  );
};

export default aneesh_topkar;
